(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ct-product-reviews"] && !Shopify.designMode) return;
  try {
    (() => {
    const openReviews = (hash, focus) => {
      if (!hash.startsWith('#ct-reviews-')) return;
      const panel = document.getElementById(hash.slice(1));
      if (!(panel instanceof HTMLDetailsElement)) return;
      panel.open = true;
      if (focus) panel.querySelector('summary')?.focus({ preventScroll: true });
      panel.scrollIntoView({ behavior: 'auto', block: 'start' });
    };
    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-ct-review-link]');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!document.getElementById(link.hash.slice(1))) return;
      event.preventDefault();
      if (location.hash !== link.hash) history.pushState(null, '', link.hash);
      openReviews(link.hash, true);
    });
    window.addEventListener('hashchange', () => openReviews(location.hash, false));
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => openReviews(location.hash, false), { once: true });
    } else {
      openReviews(location.hash, false);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    (() => {
  const syncCurrentDestination = () => {
    const isHistory = Boolean(document.querySelector('#ct-confidence'));
    const isIntention = new URLSearchParams(location.search).get('view') === 'ct-elige-por-intencion' || location.pathname.endsWith('/elige-por-intencion');
    if (!isHistory && !isIntention) return;
    document.querySelectorAll('header-drawer .menu-drawer__menu a, .menu-list__link, .menu-list__item').forEach(link => {
      const url = new URL(link.href, location.origin);
      if (url.origin !== location.origin) return;
      const intentLink = url.searchParams.get('view') === 'ct-elige-por-intencion' || url.pathname.endsWith('/elige-por-intencion');
      const historyLink = url.hash === '#ct-confidence' || url.hash === '#origen';
      const contactLink = url.hash === '#contacto';
      if (!intentLink && !historyLink && !contactLink) return;
      const active = isIntention ? intentLink : (location.hash === '#contacto' ? contactLink : historyLink);
      const currentValue = isHistory ? 'location' : 'page';
      if (active && link.getAttribute('aria-current') !== currentValue) link.setAttribute('aria-current', currentValue);
      else if (!active && link.hasAttribute('aria-current')) link.removeAttribute('aria-current');
      if (link.classList.contains('menu-list__link')) link.classList.toggle('menu-list__link--active', active);
    });
  };
  syncCurrentDestination();
  document.addEventListener('DOMContentLoaded', syncCurrentDestination, {once:true});
  document.addEventListener('toggle', event => {
    if (event.target.matches('header-drawer details')) requestAnimationFrame(syncCurrentDestination);
  }, true);
  addEventListener('hashchange', syncCurrentDestination);
  addEventListener('popstate', syncCurrentDestination);
  document.addEventListener('shopify:section:load', syncCurrentDestination);
  const header = document.querySelector('#header-component');
  if (header) new MutationObserver(syncCurrentDestination).observe(header, {childList:true, subtree:true});
})();
  } catch(e) { console.error(e); }
})();

})();
